import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Rnd } from "react-rnd";
import Cookies from 'js-cookie';
import gsap from "gsap";
import Modal from './module.modal';
import Config from "../Config.json";
import Loader from "../static/svg/loader.svg";
import {ReactComponent as ArrowBack} from "../static/icons/arrow_back.svg";
import {ReactComponent as Close} from "../static/svg/close.svg";
import {ReactComponent as Delete} from "../static/icons/delete.svg";
import {ReactComponent as Globe} from "../static/icons/globe.svg";
import {ReactComponent as AddWebview} from "../static/icons/add_webview.svg";

function Module(props) {
  const navigate = useNavigate();
  let { id } = useParams();
  const originY = useRef();
  const isDragging = useRef(false);
  const [module, setModule] = useState(null);
  const [moduleObj, setModuleObj] = useState(null);
  const [items, setItems] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [formError, setFormError] = useState();

  useEffect(() => {
    props.setTools("canvas");
    fetchJSON(null);
    props.setSmLogo(true);
    return () => props.setSmLogo(false);
  }, []);

  useEffect(() => {
    moduleObj && animModalIn(moduleObj.id);
  }, [moduleObj]);

  useEffect(() => {
    if (module) {
      setItems(module.items || []);
      if (moduleObj) {
        setModuleObj((module.items || []).find(obj => obj.id === moduleObj.id));
      }
    }
  }, [module]);

  function fetchJSON(objId) {
    try {
      axios({
        method: "get",
        url: Config.baseURL + "/api/cms/webview-grid/" + id,
        headers: { Authorization: 'Token ' + Cookies.get('_expo_tokenid') },
      }).then((response) => {
        setModule(response.data);
        setShowLoader(false);
        if (objId) {
          setModuleObj((response.data.items || []).find(a => a.id === objId));
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  function handleAddItem() {
    setShowLoader(true);
    axios({
      method: 'POST',
      url: Config.baseURL + '/api/cms/webview-grid/' + id + "/",
      data: { status: "new" },
      headers: { Authorization: 'Token ' + Cookies.get('_expo_tokenid') },
    })
    .then(response => {
      fetchJSON(response.data['id']);
    })
    .catch(error => console.log('error', error.response));
  }

  function handleItemSave(field, value) {
    if (!moduleObj || !moduleObj.id) return;
    const api_url = Config.baseURL + '/api/cms/webview-grid-item/' + moduleObj.id + "/";
    var dataJSON = {};
    dataJSON['webview_grid'] = id;
    dataJSON[field] = value;
    axios({
      method: 'POST',
      url: api_url,
      data: dataJSON,
      headers: { Authorization: 'Token ' + Cookies.get('_expo_tokenid') },
    })
    .then(() => fetchJSON(null))
    .catch(error => console.log('error', error.response));
  }

  function handleThumbnailUpload(e) {
    setShowLoader(true);
    var fileList = e.target.files;
    if (!fileList.length) return;

    let sizeMB = parseFloat(fileList[0].size / (1024 ** 2)).toFixed(2);
    if (props.user.org.validations && sizeMB > props.user.org.validations.maxFileSize) {
      setFormError({ heading: "Error", text: "File exceeds maximum upload size." });
      setShowLoader(false);
      return;
    }

    var formData = new FormData();
    formData.append('image', fileList[0], fileList[0].name);
    formData.append('webview_grid', id);
    axios({
      method: 'POST',
      url: Config.baseURL + '/api/cms/webview-grid-item/' + moduleObj.id + "/",
      data: formData,
      headers: { Authorization: 'Token ' + Cookies.get('_expo_tokenid') },
    })
    .then(() => fetchJSON(null))
    .catch(error => console.log('error', error.response));
  }

  function handleReorderSave(objs) {
    axios({
      method: 'POST',
      url: Config.baseURL + '/api/cms/webview-grid-reorder/',
      data: { webviewgriditems: objs },
      headers: { Authorization: 'Token ' + Cookies.get('_expo_tokenid') },
    })
    .then(() => fetchJSON())
    .catch(error => console.log('error', error.response));
  }

  function animModalIn(objId) {
    gsap.to("#moduleDetail_" + objId, { opacity: 1, duration: 0.2 });
  }

  function animModalOut(objId) {
    gsap.to("#moduleDetail_" + objId, { opacity: 0, duration: 0.2, onComplete: setModuleObj(null) });
  }

  function round30(x) {
    return Math.ceil(x / 30) * 30;
  }

  function reOrder(array, obj, d, setObj) {
    let reordered;
    let newArray = [...array];
    let yObj = newArray.find(obj0 => obj0.id === obj.id);

    if (yObj) {
      if (parseInt(round30(d.y) / 30) !== yObj.ordering) {
        let yObj_posY = d.y / 30 === 0 ? d.y : round30(d.y);
        let lastNumber = newArray.length - 1;
        let newOrdering = parseInt(yObj_posY / 30) - 1;
        if (newOrdering > lastNumber) newOrdering = lastNumber;
        if (newOrdering < 0) newOrdering = 0;

        let beforeNumber = [];
        let afterNumber = [];
        let sameNumber;

        if (newOrdering === 0) {
          afterNumber = newArray.filter(obj0 => obj0.ordering >= newOrdering && obj0.id !== yObj.id);
        } else if (newOrdering === lastNumber) {
          beforeNumber = newArray.filter(obj0 => obj0.ordering <= newOrdering && obj0.id !== yObj.id);
        } else {
          beforeNumber = newArray.filter(obj0 => obj0.ordering < newOrdering && obj0.id !== yObj.id);
          afterNumber = newArray.filter(obj0 => obj0.ordering > newOrdering && obj0.id !== yObj.id);
          sameNumber = newArray.find(obj0 => obj0.ordering === newOrdering && obj0.id !== yObj.id);
          if (sameNumber) {
            sameNumber.ordering = newOrdering > originY.current ? newOrdering - 1 : newOrdering + 1;
          }
        }

        beforeNumber.forEach((obj, i) => { obj.ordering = i; });
        afterNumber.forEach((obj, i) => { obj.ordering = newOrdering + i + 1; });
        yObj.ordering = newOrdering;
        originY.current = null;

        let reordered0 = newArray.filter(z => z.id > 0).sort((a, b) => a.ordering - b.ordering);
        reordered = newArray.sort((a, b) => a.ordering - b.ordering);
        let reorderedCopy = [...reordered];
        reorderedCopy.forEach((obj, i) => { obj.ordering = i; });
        setObj(reorderedCopy);

        setTimeout(() => { handleReorderSave(reordered0); }, 300);
      }
    }
    return reordered;
  }

  function handleOnKeyUp(e, field) {
    e.target.classList.add('editing');
    if (e.key === "Enter") {
      e.target.classList.remove('editing');
      handleItemSave(field, e.target.value);
    }
  }

  function itemLabel(item) {
    let label = item.title || item.webview_url || "Untitled";
    return label.length > 18 ? label.substring(0, 18) + ' ...' : label;
  }

  return (
    <section className="main">
      {showLoader && <div id="loading"><img src={Loader} alt="" /></div>}

      {formError && <Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Close"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}

      {module && (
        <div className="col appGrid">
          <div id="narrativeTools">
            <div className="iconField ui" onClick={() => handleAddItem()}>
              <AddWebview className="icon ui" title="Add WebView" onMouseEnter={(e) => props.onMouseEnter(e, "Add WebView")} onMouseLeave={() => props.onMouseLeave()} />
            </div>
            <h1>{module.title || "WebView Grid"}</h1>
          </div>

          <nav className="leftNav">
            <div className="leftArrow iconField" onClick={() => navigate('/narratives/' + module.narrative)}>
              <ArrowBack className="icon" />
              <div className="pages">Space Overview</div>
            </div>

            <div className="pages fieldRow modulePages">
              <div className="sectionRows">
                <div className="layerToggle">
                  <span className="layerToggleBtn on">WebViews</span>
                </div>
              </div>

              <div className="draggableHeading draggablePages">
                <div className="draggablePages moduleLeftNav documentNav" style={{ top: '200px' }}>
                  {items
                    .sort((a, b) => a.ordering - b.ordering)
                    .map((item, j) => (
                      <Rnd
                        className="mediaFile ui pageBtn"
                        key={'wvItem_' + j}
                        id={"page_" + item.id}
                        style={{ cursor: "default" }}
                        lockAspectRatio={true}
                        enableResizing={false}
                        dragAxis={'y'}
                        default={{ x: 0, y: j * 30, height: 30 }}
                        position={{ x: 0, y: j * 30 }}
                        onClick={() => {
                          if (!isDragging.current) {
                            setModuleObj(item);
                          }
                        }}
                        onDragStart={(e, d) => {
                          originY.current = parseInt(round30(d.y) / 30);
                        }}
                        onDrag={() => {
                          isDragging.current = true;
                        }}
                        onDragStop={(e, d) => {
                          reOrder(items, item, d, setItems);
                          setTimeout(() => { isDragging.current = false; }, 200);
                        }}
                      >
                        <span className="layerIconContainer">
                          <Globe className="icon" />
                          <span>{itemLabel(item)}</span>
                        </span>
                      </Rnd>
                    ))
                  }
                </div>
              </div>
            </div>
          </nav>

          <div className="core">
            <div className="twoCol">
              <div className="flex">
                {moduleObj && (
                  <div className="moduleDetail" id={"moduleDetail_" + moduleObj.id}>
                    <div className="moduleContainer" style={{ gridTemplateColumns: '1fr' }}>
                      <div className="closeModal ui" onClick={() => animModalOut(moduleObj.id)}>
                        <Close className="icon" />
                      </div>

                      <div className="moduleSettings">
                        <div className="groupLabel"><p>WebView Settings</p></div>

                        <div className="settingsRow">
                          <div className="moduleHeading">
                            <div className="fieldRow">
                              <div className="canvasLabel">URL</div>
                              <input
                                type="url"
                                autoComplete="off"
                                key={"url_" + moduleObj.id}
                                defaultValue={moduleObj.webview_url}
                                onKeyUp={(e) => handleOnKeyUp(e, 'webview_url')}
                                placeholder="https://"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="settingsRow">
                          <div className="moduleHeading">
                            <div className="fieldRow">
                              <div className="canvasLabel">Title</div>
                              <input
                                type="text"
                                autoComplete="off"
                                key={"title_" + moduleObj.id}
                                defaultValue={moduleObj.title}
                                onKeyUp={(e) => handleOnKeyUp(e, 'title')}
                                placeholder="Label (also used as iPad button)"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="settingsRow">
                          <div className="moduleHeading">
                            <div className="fieldRow">
                              <div className="canvasLabel">Thumbnail</div>
                              {moduleObj.image
                                ? <img src={moduleObj.image.startsWith('http') ? moduleObj.image : Config.mediaURL + moduleObj.image} alt="" className="thumbnail" onClick={() => document.getElementById("inputField_image_" + moduleObj.id).click()} />
                                : <span className="btn1 autoWidth" onClick={() => document.getElementById("inputField_image_" + moduleObj.id).click()}>Add Thumbnail</span>
                              }
                              <input
                                type="file"
                                style={{ display: "none" }}
                                autoComplete="off"
                                id={"inputField_image_" + moduleObj.id}
                                accept="image/png, image/jpeg, image/webp"
                                onChange={handleThumbnailUpload}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="settingsRow deleteRow">
                          <div
                            className="iconField ui"
                            onMouseEnter={(e) => props.onMouseEnter(e, "Double click to delete")}
                            onMouseLeave={() => props.onMouseLeave()}
                            onDoubleClick={() => {
                              props.onMouseLeave();
                              setModuleObj(null);
                              handleItemSave('delete', true);
                            }}
                          >
                            <Delete className="icon" />
                            <div className="canvasLabel">Delete Item</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div>
                  <div className="images documents">
                    {items
                      .sort((a, b) => a.ordering - b.ordering)
                      .map((item, i) => (
                        <div
                          key={'wv_tile_' + i}
                          className="thumbnail ui"
                          style={{ aspectRatio: '16/9' }}
                          onClick={() => setModuleObj(item)}
                        >
                          {item.image
                            ? <img src={item.image.startsWith('http') ? item.image : Config.mediaURL + item.image} alt="" />
                            : <figure className="thumbnail ui" style={{ background: '#3a3a3a', width: '100%', height: '100%', margin: 0 }} />
                          }
                          <div className="thumbnailCaption">
                            {item.title && <span>{item.title}</span>}
                          </div>
                        </div>
                      ))
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Module;
